import { SelectionModel } from '@angular/cdk/collections';
import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TableSelectionService<T = number> {
  highlightedRow = signal<any | null>(null);
  highlightedRows = signal<any[]>([]);
  highlightedRowsSet = computed(() => new Set(this.highlightedRows()));

  selection = new SelectionModel<T>(true); // Multi-selection for checkboxes
  singleSelection = new SelectionModel<T>(false); // Single selection for row clicks

  selectionSignal = signal<T[]>([]);
  singleSelectionSignal = signal<T>(undefined);

  selectionLength = computed(() => this.selectionSignal().length);
  hasSingle = computed(() => Boolean(this.singleSelectionSignal()));
  hasMultiple = computed(() => this.selectionLength() > 1);

  constructor() {
    this.selection.changed.subscribe(() => this.selectionSignal.set(this.selection.selected));
    this.singleSelection.changed.subscribe(() =>
      this.singleSelectionSignal.set(this.singleSelection.selected?.[0]),
    );
  }

  toggleCheckbox(id: T) {
    this.selection.toggle(id);
    this.updateSingleSelection();
  }

  selectMultiple(idsList: T[]) {
    this.selection.select(...idsList);
    this.updateSingleSelection();
  }

  deselectMultiple(idsList: T[]) {
    this.selection.deselect(...idsList);
    this.updateSingleSelection();
  }

  clearSelection() {
    this.selection.clear();
    this.singleSelection.clear();
  }

  clearHighlight() {
    this.highlightedRow.set(null);
    this.highlightedRows.set([]);
  }

  deselectAll() {
    this.clearSelection();
    this.clearHighlight();
  }

  isSelected(id: T) {
    return this.selection.isSelected(id);
  }

  isSingleSelected(id: T) {
    return this.singleSelection.isSelected(id);
  }

  private updateSingleSelection() {
    if (this.selection.selected.length === 1) {
      this.singleSelection.select(this.selection.selected[0]);
    } else {
      this.singleSelection.clear();
    }
  }
}
